<div class="modal-header">
  <h1 class="modal-title">
    <h2>
      <span>{{Komitent}}</span>
    </h2>
  </h1>
  <span class="close" (click)="Close()"><span class="fa fa-fw fa-times"></span></span>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-md-12">
      <yt-ekranska-kartica-komitenata-update #baseUpdate></yt-ekranska-kartica-komitenata-update>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button"
          class="btn btn-outline-primary mr-2"
          (click)="Print()">
    <span class="fa fa-print"></span> Štampa
  </button>

  <button type="button"
          class="btn btn-secondary"
          id="btnClose"
          (click)="Close()">
    <span>Zatvori</span>
  </button>
</div>